<template>
  <div class="com-box" v-if="tmpType == 1">
    <div class="card">
      <div class="card-title">优享置家，必须友你</div>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="time-box">
          <i class="el-icon-alarm-clock"></i>
          距离活动结束
          <span>01</span>
          天
          <span>10</span>
          小时
          <span>30</span>
          分
          <span>25</span>
          秒
        </div>
        <div class="fee-box">
          <span class="fee-text">报名费:</span>
          <span class="fee-num">￥0.01</span>
          <span class="fee-text">元</span>
        </div>
        <div class="num-box">
          <div>已浏览<span>2558</span>人</div>
          <div>已参与<span>2558</span>人</div>
        </div>
        <div class="join-info">
          <i class="el-icon-bell"></i>
          <span>张三已成功参与报名</span>
        </div>
        <div class="btn-box">
          <div class="btn">参与报名</div>
        </div>
      </div>
    </div>
  </div>
  <div class="box" v-else>
    <img :src="imgList[tmpType - 2]" alt="" />
  </div>
  
</template>

<script>
export default {
  props: {
    tmpType: String,
  },
  data() {
    return {
      imgList: [
        'https://img3.quanyou.com.cn/joyNew/group1/M00/1C/C0/rB8LrmUt-Z6AbdyRAAFcQuVmbhM825.png',
        require('@/assets/images/styleTwo/signUp.png'),
        require('@/assets/images/styleFour/bm.png'),
        require('@/assets/images/styleFive/bm.png'),
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.card
  box-sizing: border-box
  background: #FFF0EA
  padding: 5px 0
  margin 15px
  border-radius 12px
  &-title
    padding 10px 0
    text-align: center
    font-size 22px
    font-weight bold
    color #EC2F30
  &-content
    margin 0 5px 5px
    padding 10px
    background: linear-gradient(#FFE8DF, #FFB892);
    border-radius: 5px

    .time-box
      margin 10px 0
      display: flex
      align-items: center
      justify-content: center
      line-height: 20px
      i
        margin-right 5px
        font-size 18px
        font-weight 600
      span
        display: inline-block
        width 20px
        height: 20px
        padding 2px
        margin 0 1px
        text-align: center
        background-color: #FF504D
        color #FFE5CA

    .fee-box
      padding 10px 0
      text-align: center
      font-style oblique 
      font-weight bold
      color #EC2F30
      .fee-text
        font-size 16px
      .fee-num
        font-size 28px
    .num-box
      margin-bottom 10px
      display: flex
      justify-content: space-around
      span
        color #EC2F30
    .join-info
      margin 15px
      padding 5px 10px
      color #EC2F30
      background-color: #FFB892
      border-radius 5px
      span
        margin-left 5px
    .btn-box
      margin 20px 0 10px
      padding 0 10px
      text-align: center
      .btn
        padding 5px 0
        width: 100%
        height: 36px
        line-height: 36px
        color #fff
        background: linear-gradient(#FF6B31, #FF4A47);
        border-radius: 28px
        font-size 22px
        font-weight bold
.box {
  img {
    width: 100%;
    height: 100%;
  }
  
}
</style>